const Card = (props) => {
  const classes = "max-w-full  mx-auto bg-white border border-[#F1F2F9] shadow-[0px_1px_8px_rgba(25,33,61,0.06)] h-auto rounded-[32px] " + props.className;
  return <div className={classes}>{props.children}</div>;
};
export default Card;
